import * as React from "react";
import classnames from "classnames";
import { CategoryLinks, CategoryLinksItem } from "@grandvisionhq/content";
import { Heading } from "@grandvisionhq/elements";
import { Icon } from "@grandvisionhq/icons";
import { getConcatClickTrackingAttributes } from "@grandvisionhq/svc-tealium/utils";
/* empty css             */
const handleClick = (event) => {
  event.stopPropagation();
};
const renderIcon = (name) => name ? /* @__PURE__ */ React.createElement("span", { className: "submenu__icon" }, /* @__PURE__ */ React.createElement(Icon, { name })) : null;
const SubMenuLinks = ({
  items,
  ariaLabel,
  className,
  level = 1,
  handleKeyDown,
  tabIndex,
  parentTealiumAttributes
}) => /* @__PURE__ */ React.createElement("ul", { "aria-label": ariaLabel, className: classnames("submenu__items", `submenu__level-${level}`) }, items.map((item, index) => {
  if (!item.label) {
    return null;
  }
  let href = "";
  if (item.link && item.link.href) {
    href = item.link.href;
  }
  if (item.parameters && item.parameters.queryString && item.parameters.queryString.length) {
    href += item.parameters.queryString;
  }
  let action;
  if (item.parameters && item.parameters.action) {
    action = item.parameters.action;
    href = "";
  }
  const icon = item?.parameters?.icon || "";
  const tealiumAttributes = getConcatClickTrackingAttributes(
    item.label,
    parentTealiumAttributes
  );
  const classes = classnames(
    "submenu__item",
    className,
    item.link?.active && "submenu__item--active"
  );
  const onClick = item.link?.onClick ? (e) => (item.link?.onClick?.(e), handleClick(e)) : handleClick;
  return /* @__PURE__ */ React.createElement("li", { className: classes, key: `${item.label}-${index}` }, action && !href && /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "submenu__link",
      onClick: action,
      onKeyDown: handleKeyDown,
      tabIndex
    },
    renderIcon(icon),
    item.label
  ), href && !action && /* @__PURE__ */ React.createElement(
    "a",
    {
      className: "submenu__link",
      onClick,
      href,
      "data-t": item.parameters?.testId ? `submenu-link-${item.parameters.testId}` : void 0,
      ...tealiumAttributes,
      onKeyDown: handleKeyDown,
      tabIndex
    },
    renderIcon(icon),
    item.label
  ), !href && !action && /* @__PURE__ */ React.createElement("p", null, renderIcon(icon), item.label), item.childMenuItems?.length ? /* @__PURE__ */ React.createElement(
    SubMenuLinks,
    {
      items: item.childMenuItems,
      ariaLabel: item.label,
      level: 2,
      handleKeyDown,
      tabIndex,
      parentTealiumAttributes: tealiumAttributes
    }
  ) : null);
}));
const getCategoryLinksItem = (item) => {
  const link = item.link && item.link.href || "";
  const imageUrl = item.parameters && item.parameters.image || "";
  return {
    title: item.label,
    link: { url: link, target: "internal" },
    image: { url: imageUrl, dimensions: { w: 200, h: 170 } }
  };
};
const hasCategoryLinks = (menuItems) => {
  const imageItems = menuItems.filter((item) => item.parameters && item.parameters.image);
  return !!imageItems.length;
};
const SubMenu = ({
  menuItems,
  isActive = false,
  closeSubMenu,
  parentTealiumAttributes
}) => {
  const hasImages = hasCategoryLinks(menuItems);
  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      closeSubMenu();
    }
  };
  const tabIndex = isActive ? void 0 : -1;
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      "data-t": "site-nav-submenu",
      "aria-hidden": !isActive,
      className: classnames("submenu", {
        "submenu--with-image": hasImages,
        _is_active: isActive
      })
    },
    /* @__PURE__ */ React.createElement("div", { className: "submenu__content" }, menuItems.map((item) => {
      const tealiumAttributes = getConcatClickTrackingAttributes(
        item.label,
        parentTealiumAttributes
      );
      return /* @__PURE__ */ React.createElement("div", { className: "submenu__column", key: item.label }, item.parameters && item.parameters.image && /* @__PURE__ */ React.createElement(CategoryLinks, null, "[", /* @__PURE__ */ React.createElement(CategoryLinksItem, { ...getCategoryLinksItem(item) }), "]"), item.link && item.link.href ? /* @__PURE__ */ React.createElement(
        "a",
        {
          className: "submenu__link",
          href: item.link.href,
          "data-t": "submenu-title-link",
          onClick: handleClick,
          onKeyDown: handleKeyDown,
          tabIndex,
          ...tealiumAttributes
        },
        /* @__PURE__ */ React.createElement(
          Heading,
          {
            variant: "small",
            className: "submenu__title",
            component: "div",
            visualHeadingOnly: true
          },
          item.label
        )
      ) : /* @__PURE__ */ React.createElement(
        Heading,
        {
          variant: "small",
          className: "submenu__title",
          component: "div",
          visualHeadingOnly: true
        },
        item.label
      ), item.childMenuItems?.length ? /* @__PURE__ */ React.createElement(
        SubMenuLinks,
        {
          items: item.childMenuItems,
          ariaLabel: item.label,
          handleKeyDown,
          tabIndex,
          parentTealiumAttributes: tealiumAttributes
        }
      ) : null);
    }))
  );
};
export {
  SubMenu,
  SubMenuLinks,
  SubMenu as default
};
//# sourceMappingURL=SubMenu.js.map
